/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Participatedulworkshopcompentenceone5Inputs */

const de__field_participatedulworkshopcompentenceone5 = /** @type {(inputs: _Field_Participatedulworkshopcompentenceone5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teilgenommen an ÜL-Workshop Competence One`)
};

/**

* @param {_Field_Participatedulworkshopcompentenceone5Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_participatedulworkshopcompentenceone5 = /** @type {((inputs?: _Field_Participatedulworkshopcompentenceone5Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Participatedulworkshopcompentenceone5Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_participatedulworkshopcompentenceone5(inputs)
});
export { _field_participatedulworkshopcompentenceone5 as "_field_participatedULWorkshopCompentenceOne" }